(() => {
    "use strict";

    const entries = [];

    document
        .querySelectorAll(".fr-notebook-data-entry")
        .forEach((element) => {
            entries.push({
                id: element.dataset.notebookId || "",
                slug: element.dataset.notebookSlug || "",
                title: element.dataset.notebookTitle || "",
                url: element.dataset.notebookUrl || "",
                date: element.dataset.notebookDate || "",
                section: element.dataset.notebookSection || ""
            });
        });

    function getEntry(slug) {
        return entries.find(
            (entry) => entry.slug === slug
        ) || null;
    }

    function getEntryRoute(slug) {
        const entry = getEntry(slug);

        if (!entry) {
            return "";
        }

        return entry.url || "";
    }

    window.frNotebookCatalog = {
        getEntries() {
            return [...entries];
        },

        getEntry,

        getEntryRoute
    };
})();